module.exports = __webpack_public_path__ + "static/img/仪器设备.95c98c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/一级标题Banner/仪器设备.jpg
// module id = /zLW
// module chunks = 16